import Modal from 'developer_components/newModal';
import EventEmitter from 'methods/eventEmitter';

/**
 * Модалка забыл пароль
 */
function ChangePasswordModal(data = {}) {
    // наследуемся
    EventEmitter.call(this);

    this.modal_id  = 'changePassword';
    this._$element = Modal.createFromHTML(
        `<div class="Change-modal container">
            <div class="background"></div>
            <div class="form">
                <div class="form-header">
                    <div class="mobile-wrapper">
                        <div class="logo"></div>
                        <button class="close-button js-modalClose"></button>
                    </div>
                    <div class="cross-wrapper"><div class="cross js-modalClose"></div></div>
                </div>
                <div class="form-content">
                    <div class="header-title">Сменить пароль для пользователя ${data.email}</div>
                    <form action="${data.action}" method="post" class="fields">
                        <div class="field password-field" data-type="password1">
                            <span class="title">Новый пароль</span>
                            <div class="password-input-wrapper">
                                <input type="password" name="password1" class="input" required placeholder="••••••••">
                                <div class="eye js-passwordVisibility"></div>
                            </div>
                            <span class="hint"></span>
                        </div>

                        <div class="field password-field" data-type="password2">
                            <span class="title">Подтвердите пароль</span>
                            <div class="password-input-wrapper">
                                <input type="password" name="password2" class="input" required placeholder="••••••••">
                                <div class="eye js-passwordVisibility"></div>
                            </div>
                            <span class="hint"></span>
                        </div>

                        <button class="button">Войти</button>
                    </form>
                    <div class="caption">
                        <p>Авторизуясь, вы соглашаетесь с правилами использования сервиса и обработки <a href="/about/polzovatelskoe_soglashenie/" target="_blank">персональных данных</a>.</p>
                        <p><a href="https://privettur.ru/about/obrabotka_personalnyh_dannyh/" target="_blank">Политика в отношении обработки персональных данных</a></p>
                        <p><a href="https://privettur.ru/about/soglasie_na_obrabotku_personalnyh_dannyh/" target="_blank">Согласие на обработку персональных данных</a></p>
                    </div>
                </div>
                <div class="form-footer">
                    У вас еще нет аккаунта? <span class="link" data-modal_id="registration">Зарегистрироваться</span>
                </div>
            </div>
        </div>`,
        {
            id: this.modal_id,
        }
    );

    // наследование
    Modal.call(this, this._$element, {
        modal_id: this.modal_id,
    });

    this._events = {
        togglePasswordVisibility: (e) => {
            let $eye   = e.target;
            let $input = e.target.parentNode.querySelector('input');
            let type   = $input.getAttribute('type') === 'password' ? 'text' : 'password';

            $eye.classList.toggle('active', !$eye.classList.contains('active'));
            $input.setAttribute('type', type);
        },
        submit: (e) => {
            e.preventDefault();
            e.stopPropagation();

            // защита от повторной отправки
            if (this._$form.classList.contains('is-loading')) {
                return false;
            }
            this._$form.classList.add('is-loading');

            // убираем ошибки
            this._$element.querySelectorAll('.field').forEach($field => {
                $field.classList.remove('error');

                let $hint = $field.querySelector('.hint');
                if ($hint) {
                    $hint.textContent = '';
                }
            });

            fetch(this._$form.getAttribute('action'), {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: new FormData(this._$form),
            })
            .then(response => response.json())
            .then(r => {
                if (r.status === 'ok' && r.redirect) {
                    this.emit('success', r.redirect);
                } else if (r.fields) {
                    this._$element.querySelectorAll('.field').forEach($field => {
                        let name = $field.dataset.type;
                        if (name && r.fields[name]) {
                            $field.classList.add('error');

                            let $hint = $field.querySelector('.hint');
                            if ($hint) {
                                $hint.textContent = r.fields[name];
                            }
                        }
                    });
                } else if (r.message) {
                    alert(r.message);
                }

                this._$form.classList.remove('is-loading');
            });
        }
    }

    this.init = function() {
        this._$form = this._$element.querySelector('form');
        this._$form.addEventListener('submit', this._events.submit);

        // показать пароль
        this._$element.querySelectorAll('.js-passwordVisibility').forEach($item => $item.addEventListener('click', this._events.togglePasswordVisibility));
    }
    this.init();
}

ChangePasswordModal.prototype = Object.create(Modal.prototype, {
    constructor: {
        value: ChangePasswordModal,
        enumerable: false,
        writable: true,
    }
});

export default ChangePasswordModal;